<template>
  <div class="circle-row__item circle-row__item--total">
    <slot name="title">
      <span>
        {{ title || '' }}
      </span>
    </slot>
    <slot name="amount">
      <span>
        {{ amount || '' }}
      </span>
    </slot>
    <g-chart
      class="pie-chart-total"
      type="PieChart"
      :settings="{ packages: ['corechart'] }"
      :data="data"
      :options="{
        enableInteractivity: false,
        width: '96px',
        height: '96px',
        chartArea: { width: '100%', height: '100%', top: '0', left: '0' },
        legend: { position: 'none' },
        pieHole: 0.9,
        slices: slices
      }"
    />
  </div>
</template>

<script>
  import { GChart } from 'vue-google-charts';

  export default {
    components: { GChart },
    props: {
      title: {
        type: String,
        default: null
      },

      amount: {
        type: [String, Number],
        default: null
      },

      data: {
        type: Array,
        default: () => []
      },

      colors: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      slices: function() {
        return this.colors.map(i => ({ color: i }));
      }
    }
  };
</script>
